export default __webpack_public_path__ + "static/media/youtubeGrey.c007b6ce.svg";